module.exports = __webpack_public_path__ + "assets/img/conversion_coin.40cc6d53.png";